import { Routes } from '@angular/router';
import { authGuard } from './core/auth';
import { AppShell } from './layout/app-shell/app-shell';
import { GetLabels } from './pages/get-labels/get-labels';
import { CancelShipmentPage } from './pages/cancel-shipment/cancel-shipment';
import { ShipFromShipTo } from './pages/ship-from-ship-to/ship-from-ship-to';
import { LoginCallback } from './pages/login-callback/login-callback';
import { PackageSelection } from './pages/package-selection/package-selection';
import { ReviewAndPay } from './pages/review-and-pay/review-and-pay';
import { reviewAndPayLeaveGuard } from './pages/review-and-pay/review-and-pay-leave.guard';
import { ServiceStep } from './pages/service-step/service-step';
import { ShipmentDetailsPrint } from './pages/shipment-details-print/shipment-details-print';
import { SignedOut } from './pages/signed-out/signed-out';
import { RoutingTest } from './pages/routing-test/routing-test';
import { routingTestLegacyRedirect } from './pages/routing-test/routing-test-legacy.redirect';

export const routes: Routes = [
  {
    path: 'login/callback',
    component: LoginCallback,
  },
  {
    path: 'signed-out',
    component: SignedOut,
  },
  {
    // Opened in a new tab from Get Labels; no AppShell chrome so it can be printed as-is.
    path: 'shipment-details-print',
    component: ShipmentDetailsPrint,
    canActivate: [authGuard],
  },
  {
    path: '',
    component: AppShell,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        component: ShipFromShipTo,
      },
      {
        path: 'package',
        component: PackageSelection,
      },
      {
        path: 'service',
        component: ServiceStep,
      },
      {
        path: 'review',
        component: ReviewAndPay,
        canDeactivate: [reviewAndPayLeaveGuard],
      },
      {
        path: 'get-labels',
        component: GetLabels,
      },
      {
        path: 'cancel-shipment',
        component: CancelShipmentPage,
      },
      {
        path: 'routing-test',
        component: RoutingTest,
      },
      {
        path: 'routing-test/legacy',
        canActivate: [routingTestLegacyRedirect],
        component: RoutingTest,
      },
      {
        path: 'routing-test/detail/:itemId',
        component: RoutingTest,
      },
    ],
  },
];
